module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.b37d0bb7.ttf";